import { Auth } from 'aws-amplify'
import { mapActions } from 'vuex'

export default {
  state: {
    loggedIn: false,
    error: '',
    user: {
      username: '',
      token: '',
      attributes: []
    },
    access: {
      modal: false,
      role: '',
      json: ''
    }
  },
  getters: {
    hasError (state) {
      return state.error.length > 0
    },
    getUser (state) {
      return state.user
    }
  },
  mutations: {
    setLoggedIn (state, login) {
      state.loggedIn = login
    },
    setUser (state, user) {
      Object.assign(state.user, user)
    },
    setError (state, error = '') {
      state.error = error
    },
    setAccess (state, val) {
      state.access = val
    },
    setAccessModal (state, val) {
      state.access = { ...state.access, modal: val }
    },
    setAccessRole (state, val) {
      state.access = { ...state.access, role: val }
    },
    setAccessJson (state, val) {
      state.access = { ...state.access, json: val }
    }
  },
  actions: {
    ...mapActions(['setTokenExpiry']),
    toggleAccessModal (context) {
      context.commit('setAccessModal', !context.state.access.modal)
    },
    login (context, user) {
      context.commit('setLoggedIn', true)
      context.commit('setUser', user)
      context.commit('setTokenExpiry', user.expiry)
    },

    logout (context) {
      Auth.signOut().then(() => {
        context.commit('setLoggedIn', false)
        window.location.reload()
      })
    }
  }
}
